import { createSlice } from '@reduxjs/toolkit';

import * as clientApi from '../services/clientApi';

export const adminsSlice = createSlice({
  name: 'adminsList',
  initialState: [],
  reducers: {
    set: (_, action) => action.payload,
    add: (admins, action) => [...admins, action.payload],
    remove: (admins, action) => admins.filter(c => c.id !== action.payload),
    change: (admins, { payload: { id, ...admin } }) =>
      admins.map(a => (a.id !== id ? a : { ...a, ...admin })),
  },
});

export const { set, add, remove, change } = adminsSlice.actions;

export default adminsSlice.reducer;
